export class UserPermissionsRequest{
    public IsGroup:boolean = false;
    public IncludeSublocations:boolean = false;
    public LocationID:number = -1;
    public FullLocationList:number[] = [];
    constructor(values: Object = {}) {

        Object.assign(this, values);
    }
}
